/* eslint-disable max-len */
import { memo, useState } from "react";
import { Popup } from "components/UI/Popup";
import { INITIAL_STEP, SUCCESS_STEP, CREATE_STEP } from "./constants";
import { CreateFormContainer as CreateForm } from "./CreateFormContainer";
import "./styles/CreateNichePopup.scss";

interface ICreateNichePopup {
  isOpen: boolean;
  onClose: () => void;
}

interface StepMap {
  [key: string]: {
    title: string | undefined;
    render: () => JSX.Element;
    btnProps: {
      type?: number;
      title?: string;
      onClick?: () => void;
    };
  };
}

export const CreateNichePopup = memo((props: ICreateNichePopup) => {
  const [step, setStep] = useState(INITIAL_STEP);
  const { isOpen, onClose } = props;

  const renderNicheInfo = () => (
    <div className="CreateNichePopup-NicheInfo">
      <p>Niches are public spaces where the RedGIFs community can collect and collate content in and around a specific theme.</p>
      <div>
        <h3>Submitting your niche </h3>
        <p>On the next screen you can submit the details of your new niche including your own posting guidelines to help other RedGIFs users know the type of content your niche is intended for.</p>
      </div>
      <div>
        <h3>What happens next?</h3>
        <p>Our community team reviews each submission against our community guidelines (link off to FAQs with Niche explanations) and you will receive a response when the review is complete.</p>
      </div>
      <p>Please click Continue to enter the details of your niche.</p>
    </div>
  );

  const renderNicheSuccess = () => (
    <div className="CreateNichePopup-NicheSuccess">
      <p>Congratulations! Your niche has been submitted  to our community team for review.</p>
      <p>Due to the popularity of niches, the review process can take up to 48 hours, so please wait at least two days before following up on your submission.</p>
      <p>Thanks again for your interest in creating a new niche on RedGIFs!</p>
    </div>
  );

  const stepMap: StepMap = {
    [INITIAL_STEP]: {
      title: "Create a Niche",
      render: () => renderNicheInfo(),
      btnProps: {
        type: 1,
        title: "Continue",
        onClick: () => setStep(CREATE_STEP),
      }
    },
    [CREATE_STEP]: {
      title: undefined,
      render: () => <CreateForm handleGoSuccess={() => setStep(SUCCESS_STEP)} />,
      btnProps: {}
    },
    [SUCCESS_STEP]: {
      title: "Success",
      render: () => renderNicheSuccess(),
      btnProps: {
        type: 1,
        title: "Close",
        onClick: onClose
      }
    }
  };

  const { title, render, btnProps } = stepMap[step];

  return (
    <Popup
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      popupClass="CreateNichePopup"
      btnProps={btnProps}
    >
      {render()}
    </Popup>
  );
});
